import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
// import 'v-currency-field/dist/index.css'

Vue.use(Vuetify, {
  iconfont: 'md',
})
